<ng-template #toolbarEditMode let-inSidebar="inSidebar">
  <div *ngIf="fullEditModeEnabled && canUpdate && !disabledTableActions.includes(TABLE_ACTIONS.FULL_EDIT_MODE)" class="ag-grid-toolbar-edit-mode">
    <div class="ag-grid-toolbar-edit-toggle">
      <i class="pi pi-eye" [style]="{
          'font-size': '1em',
          color: isFullEditMode ? '' : 'var(--primary-color)'
        }"></i>
      <p-inputSwitch [(ngModel)]="isFullEditMode" [disabled]="activeRowEdit"
        (onChange)="toggleFullEditMode()"></p-inputSwitch>
      <i class="pi pi-pencil" [style]="{
          'font-size': '1em',
          color: isFullEditMode ? 'var(--primary-color)' : ''
        }"></i>
    </div>
    <div *ngIf="this.isTableEditLocked">
      <strong>Table Editing Disabled. Row Editing is Active</strong>
    </div>
    <p-button class="p-button-sm" *ngIf="isFullEditMode" label="Save Changes"
      (click)="submitFullEdit(); inSidebar && closeToolbarSidebar()"></p-button>
  </div>
</ng-template>

<ng-template #toolbarPrimaryActions let-inSidebar="inSidebar">
  <div class="ag-grid-toolbar-actions">
    <div *ngIf="tableParams && tableParams.customButtons">
      <p-button *ngIf="tableParams.customButtons.includes('archived')"
        [label]="showArchived ? 'Hide Archived' : 'Show Archived'" class="p-button-sm"
        [styleClass]="showArchived ? '' : 'p-button-outlined'"
        [icon]="showArchived ? 'pi pi-inbox' : 'pi pi-folder'" type="button"
        (click)="applyCustomFilter('archived'); inSidebar && closeToolbarSidebar()"></p-button>
    </div>

    <p-button
      *ngIf="(entity == 'items' || entity == 'challenges' || entity == 'miscellaneous-build') && !isTableInput"
      [label]="isGridViewVisible ? 'Grid' : 'Rows'"
      [icon]="isGridViewVisible ? 'fa-solid fa-grip' : 'fa-solid fa-table'"
      styleClass="p-button-sm"
      (click)="toggleGrid(); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button label="Clear Sorting" [badge]="sortCounter" icon="pi pi-sort-alt-slash" styleClass="p-button-sm"
      (click)="clearSorting(); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button label="Clear Filters" [badge]="filterCounter" icon="pi pi-filter-slash" styleClass="p-button-sm"
      (click)="clearFilters(); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button
      *ngIf="!hideActions && !isTableInput && !disabledTableActions.includes(TABLE_ACTIONS.ACTIONS)"
      [label]="TABLE_ACTIONS.ACTIONS"
      styleClass="p-button-sm"
      icon="pi pi-cog"
      type="button"
      (click)="inSidebar ? onToolbarActionsClick() : actionsDialog.show()"
    ></p-button>

    <ng-container *ngIf="!disabledTableActions.includes(TABLE_ACTIONS.TABLE_SEARCH)">
      <!-- Items and Challenges opt into AI tag search via tableParams.aiSearch; every
           other grid keeps the original name/fileName box. -->
      <ai-table-search
        *ngIf="tableParams?.aiSearch; else plainTableSearch"
        [term]="globalSearchTerm"
        [mode]="aiSearchMode"
        [fallbackPlaceholder]="TABLE_ACTIONS.TABLE_SEARCH"
        (searchChange)="onAiSearchChange($event)"
      ></ai-table-search>

      <ng-template #plainTableSearch>
        <span class="p-input-icon-left ag-grid-toolbar-search">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [placeholder]="TABLE_ACTIONS.TABLE_SEARCH" [(ngModel)]="globalSearchTerm" (input)="onSearchInputChange()" />
        </span>
      </ng-template>
    </ng-container>

    <a
      *ngIf="tableParams && !tableParams.hideAdd && !isLoading && !isDynamicListTable && !tableParams.enablePopUpForm"
      [href]="urlNewForm" target="_blank" style="text-decoration: none"
    >
      <p-button
        *ngIf="!isTableInput && canCreate && !disabledTableActions.includes(TABLE_ACTIONS.NEW)"
        [label]="TABLE_ACTIONS.NEW"
        icon="pi pi-fw pi-plus"
        class="p-button-sm"
        type="button"
        data-testid="btn-new"
      ></p-button>
    </a>

    <p-button
      *ngIf="tableParams && !tableParams.hideAdd && !isLoading && !isDynamicListTable && tableParams.enablePopUpForm && !isTableInput && canCreate && !disabledTableActions.includes(TABLE_ACTIONS.NEW)"
      [label]="TABLE_ACTIONS.NEW"
      icon="pi pi-fw pi-plus"
      class="p-button-sm"
      type="button"
      (click)="openPopupForm(); inSidebar && closeToolbarSidebar()"
      data-testid="btn-new"
    ></p-button>
    <p-button
      *ngIf="isDynamicListTable && canCreate && !disabledTableActions.includes(TABLE_ACTIONS.NEW)"
      [label]="TABLE_ACTIONS.NEW"
      icon="pi pi-fw pi-plus"
      class="p-button-sm"
      type="button"
      (click)="showDynamicDialog(); inSidebar && closeToolbarSidebar()"
      data-testid="btn-new"
    ></p-button>
    <p-button
      *ngIf="isTableInput"
      label="Add"
      icon="pi pi-fw pi-plus"
      class="p-button-sm"
      type="button"
      (onClick)="addSelectedData(); inSidebar && closeToolbarSidebar()"
    ></p-button>

    <div *ngIf="tableParams && tableParams.customButtons" class="ag-grid-toolbar-actions">
      <p-button *ngIf="tableParams.customButtons.includes('addAsset')" label="Add Asset" class="p-button-sm"
        icon="fa-solid fa-circle-plus" type="button" (click)="showAssetDialog(); inSidebar && closeToolbarSidebar()"></p-button>
      <p-button *ngIf="tableParams.customButtons.includes('syncStoreListings')"
        label="Sync Store Listings with Admin Panel" class="p-button-sm" icon="fa-solid fa-rotate"
        type="button" (click)="syncStore(); inSidebar && closeToolbarSidebar()"></p-button>
      <p-button *ngIf="tableParams.customButtons.includes('addString')" label="Add" class="p-button-sm"
        icon="fa-solid fa-circle-plus" type="button" (click)="showStringDialog(); inSidebar && closeToolbarSidebar()"></p-button>
      <p-button *ngIf="tableParams.customButtons.includes('importCsvClientStrings')" label="Import CSV" class="p-button-sm"
        icon="pi pi-upload" type="button" (click)="showImportCsvDialog(); inSidebar && closeToolbarSidebar()"></p-button>
    </div>
  </div>
</ng-template>

<ng-template #toolbarSecondaryActions let-inSidebar="inSidebar">
  <div class="ag-grid-toolbar-actions">
    <ng-container *ngIf="tableParams?.customActionButtons?.includes('addToCart') && entity == 'store-listings-v2'">
      <p-button label="Add to Cart" styleClass="p-button-sm" icon="fa-solid fa-cart-shopping " type="button"
        (click)="addToCart('store-listings'); inSidebar && closeToolbarSidebar()">
      </p-button>
    </ng-container>

    <ng-container *ngIf="tableParams?.customActionButtons?.includes('addToCart') && entity == 'price-points'">
      <p-button label="Add to Cart" styleClass="p-button-sm" icon="fa-solid fa-cart-shopping " type="button"
        (click)="addToCart('price-points'); inSidebar && closeToolbarSidebar()">
      </p-button>
    </ng-container>

    <p-button
      *ngIf="tableParams?.customActionButtons?.includes('enableRowSelectionForAssistant')"
      label="Send Selected Items To AI Assistant"
      icon="fa-solid fa-layer-group"
      class="p-button-sm"
      [styleClass]="isAiAssistantPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      [disabled]="!areRowsSelected"
      (click)="passSelectedItemsToAiAssistant(); inSidebar && closeToolbarSidebar()"
    ></p-button>

    <p-button
      *ngIf="entity === 'items'"
      label="Item Sets"
      icon="fa-solid fa-layer-group"
      class="p-button-sm"
      [styleClass]="isItemSetsPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      (click)="togglePanel('itemSets'); inSidebar && closeToolbarSidebar()"
    ></p-button>

    <p-button label="Columns" [outlined]="true" icon="fa-solid fa-table-columns"
      [styleClass]="isColumnsPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      (click)="togglePanel('columns'); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button *ngIf="!disabledTableActions.includes(TABLE_ACTIONS.COLUMNS_PRESETS)" [label]="TABLE_ACTIONS.COLUMNS_PRESETS" icon="fa-solid fa-diagram-successor"
      [styleClass]="isColumnPresetsPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      (click)="togglePanel('columnPresets'); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button label="Filters" icon="pi pi-filter"
      [styleClass]="isFiltersPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      (click)="togglePanel('filters'); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button *ngIf="!disabledTableActions.includes(TABLE_ACTIONS.SAVED_FILTERS)" [label]="TABLE_ACTIONS.SAVED_FILTERS" icon="pi pi-filter-fill"
      [styleClass]="isSavedFiltersPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      (click)="togglePanel('cmsFilters'); inSidebar && closeToolbarSidebar()">
    </p-button>

    <p-button *ngIf="!isGridViewVisible && !disabledTableActions.includes(TABLE_ACTIONS.GRID_VIEW_SETTINGS)" [label]="TABLE_ACTIONS.GRID_VIEW_SETTINGS"
      [icon]="isGridViewSettingsVisible ? 'fa-solid fa-grip' : 'fa-solid fa-table'"
      [styleClass]="isGridViewSettingsVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
      (click)="togglePanel('gridViewSettings'); inSidebar && closeToolbarSidebar()">
    </p-button>
  </div>
</ng-template>

<div *ngIf="!tableParams?.hideHeader" class="ag-grid-table-header">
  <div class="ag-grid-header-title-row">
    <div class="ag-grid-header-title">
      <h2 *ngIf="!isTableInput" class="p-mx-1 p-my-1">{{tableParams?.customName || parse(entity) + ' Table'}}</h2>
      <!-- One pin per table: favorites are per entity type, not per record. -->
      <app-favorite-toggle
        *ngIf="!isTableInput && entity && !entity.includes('/')"
        [entity]="entity"
        [name]="tableParams?.customName || parse(entity)"
        [small]="true">
      </app-favorite-toggle>
      <ng-container *ngIf="totalRowCount && tableTotalRecords">
        <p-badge [value]="totalRowCount + ' / ' + tableTotalRecords" size="medium" class="p-mx-1 p-mt-1">
        </p-badge>
      </ng-container>
      <ng-container *ngIf="selectedRowsSet.size < 1; else rowsAreSelected">
        <p-badge *ngIf="!disabledTableActions.includes(TABLE_ACTIONS.ROW_SELECTED)" [value]="selectedRowsSet.size + ' Rows Selected'" size="medium" class="p-mx-1 p-mt-1">
        </p-badge>
      </ng-container>
      <ng-template #rowsAreSelected>
        <p-badge (click)="onResetRows(true)" [value]="selectedRowsSet.size + ' Rows Selected (Clear)'" size="medium"
          severity="warning" class="p-mx-1 p-mt-1">
        </p-badge>
      </ng-template>
      <div class="ag-grid-toolbar-desktop ag-grid-header-edit-mode">
        <ng-container *ngTemplateOutlet="toolbarEditMode; context: { inSidebar: false }"></ng-container>
      </div>
    </div>

    <div class="ag-grid-header-mobile-actions">
      <p-button
        label="Table Tools"
        icon="pi pi-sliders-h"
        styleClass="p-button-sm"
        (click)="openToolbarSidebar()"
      ></p-button>
    </div>
  </div>

  <div class="ag-grid-toolbar-desktop">
    <div class="ag-grid-toolbar-row ag-grid-toolbar-row--primary">
      <ng-container *ngTemplateOutlet="toolbarPrimaryActions; context: { inSidebar: false }"></ng-container>
    </div>
    <div class="ag-grid-toolbar-row ag-grid-toolbar-row--secondary">
      <ng-container *ngTemplateOutlet="toolbarSecondaryActions; context: { inSidebar: false }"></ng-container>
    </div>
  </div>
</div>

<p-sidebar
  [(visible)]="isToolbarSidebarOpen"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [showCloseIcon]="true"
  styleClass="ag-grid-toolbar-sidebar"
  [blockScroll]="true"
>
  <ng-template pTemplate="header">
    <span class="font-bold">Table Tools</span>
  </ng-template>

  <div class="ag-grid-toolbar-sidebar-content">
    <div class="ag-grid-toolbar-section" *ngIf="fullEditModeEnabled && canUpdate && !disabledTableActions.includes(TABLE_ACTIONS.FULL_EDIT_MODE)">
      <p class="ag-grid-toolbar-section-label">Edit Mode</p>
      <ng-container *ngTemplateOutlet="toolbarEditMode; context: { inSidebar: true }"></ng-container>
    </div>

    <div class="ag-grid-toolbar-section">
      <p class="ag-grid-toolbar-section-label">Actions</p>
      <ng-container *ngTemplateOutlet="toolbarPrimaryActions; context: { inSidebar: true }"></ng-container>
    </div>

    <div class="ag-grid-toolbar-section">
      <p class="ag-grid-toolbar-section-label">Panels</p>
      <ng-container *ngTemplateOutlet="toolbarSecondaryActions; context: { inSidebar: true }"></ng-container>
    </div>
  </div>
</p-sidebar>

<div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; z-index: 9999;" *ngIf="loadingGrid">
  <p-progressSpinner
    styleClass="custom-spinner"
    strokeWidth="4"
    animationDuration="1s"></p-progressSpinner>
</div>


<div class="ag-grid-scroll-container">
  <button
    *ngIf="showAgSidePanelCloseButton"
    type="button"
    class="ag-grid-side-panel-close-btn"
    aria-label="Close columns and filters panel"
    (click)="closeAgSidePanel()"
  >
    <i class="pi pi-times"></i>
    <span>Close panel</span>
  </button>
  <ag-grid-angular
  #agGrid
  [gridOptions]="gridOptions"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [rowData]="rowData"
  [class]="gridTheme"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged($event)"
  (paginationChanged)="onPaginationChanged($event)"
  (rowSelected)="onRowSelected($event)"
  [ngStyle]="{
    'border': isFullEditMode ? '2px solid #81C784' : 'none',
    'width': '100%',
    'height': getGridHeight()|| tableHeight || 'auto'
  }"
  data-testid="entity-grid"
>
</ag-grid-angular>
</div>

<p-dialog
  [(visible)]="dialogImageUrl"
  [dismissableMask]="true"
  [modal]="true"
  [transitionOptions]="'200ms'"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '50vw', height: '80vh', overflow: 'hidden' }"
>
  <ng-template pTemplate="header">
    <h3 class="p-m-0">{{ dialogImageTitle ? dialogImageTitle : 'Thumbnail' }}</h3>
  </ng-template>

  <div class="p-text-center p-p-0" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; overflow: hidden;">
    <img *ngIf="dialogImageUrl"
         [src]="dialogImageUrl + '?ts=' + timestamp"
         style="width: auto; max-width: 100%; height: auto; max-height: 100%; object-fit: contain;" />
  </div>
</p-dialog>


<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<app-ag-grid-actions #actionsDialog [gridApi]="api" [columnApi]="columnApi" [entity]="entity" [mongoQuery]="mongoQuery"
  [mongoSort]="mongoSort" [bulkUpdateColDefs]="bulkUpdateColDefs"
  [areRowsSelected]="areRowsSelected" [rowsSelected]="rowsSelected" [selectedRowsSet]="selectedRowsSet"
  [isSelectAll]="isSelectAll" [loadedRowCount]="loadedRowCount"
  [totalRecords]="totalRowCount" [changedRows]="changedRows" [buildParams]="buildParams" [userParams]="userParams"
  [tableParams]="tableParams" [populateFields]="populateFields" [tableInstanceId]="tableInstanceId"
  [fetchAllRowsFromBackend]="fetchAllRowsFromBackend.bind(this)"></app-ag-grid-actions>

<asset-popup-form
  *ngIf="tableParams && tableParams.customButtons && tableParams.customButtons.includes('addAsset') && imagerySettingsLoaded && entityTypesLoaded"
  [isVisible]="displayAssetDialog" [entity]="miscAssetEntity" [parentEntityTypeOptions]="entityTypeOptions"
  [imagerySettings]="imagerySettings" [type]="'miscellaneous-build'" [buildType]="3"
  (formSubmitted)="reloadDataSource($event)" [showOnAssetBundleOnly]="false"
  (onHide)="hideAssetDialog()"></asset-popup-form>

<string-popup-form (onHide)="hideStringDialog()" [type]="entity" [isVisible]="displayStringDialog">

</string-popup-form>

<p-toast></p-toast>
<app-dup-dialog #dupDialog [entity]="entity" [viewRoute]="viewRoute" (duplicationSuccess)="handleDuplicationSuccess($event)"></app-dup-dialog>
<dynamic-dialog-form
  *ngIf="isDynamicListTable"
  [(visible)]="showDynamicForm"
  [header]="'Add New ' + parse(entity)"
  [fields]="dynamicFormFields"
  [entity]="entity"
  (onSubmit)="handleDynamicFormSubmit($event)"
  (onCancel)="handleDynamicFormCancel()"
></dynamic-dialog-form>

<p-dialog 
  [(visible)]="dialogVisible" 
  [modal]="true" 
  [closable]="false" 
  [header]="dialogData?.header" 
  [style]="{width: '600px'}"
>
  <div *ngIf="dialogData">
    <p>{{ dialogData.content }}</p>
    <div style="max-height: 150px; overflow-y: auto; margin-top: 10px;">
      <p *ngIf="dialogData.ids">Referenced IDs: {{ dialogData.ids.join(', ') }}</p>
    </div>
    <p-footer>
      <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
        <button 
          pButton 
          label="{{ dialogData.footerLabel }}" 
          (click)="closeDialog()" 
        ></button>
      </div>
    </p-footer>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="displayImportCsvDialog"
  header="Import Client Strings from CSV"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '520px' }"
  (onHide)="hideImportCsvDialog()"
>
  <!-- Hidden native file input — fully controlled from TS -->
  <input
    #csvFileInput
    type="file"
    accept=".csv"
    style="display:none"
    (change)="onImportCsvNativeChange($event)"
  />

  <div style="display:flex; flex-direction:column; gap:1rem;">

    <!-- Step 1: Template -->
    <div style="display:flex; align-items:center; gap:0.75rem; padding:0.75rem; background:var(--surface-100); border-radius:6px;">
      <i class="pi pi-file-excel" style="font-size:1.5rem; color:var(--primary-color);"></i>
      <div style="flex:1;">
        <div style="font-weight:600; margin-bottom:0.2rem;">CSV Template</div>
        <div style="font-size:0.82rem; color:var(--text-color-secondary);">Required: <strong>id</strong>, <strong>Source_en</strong>. Optional: Target_frFR, Target_esMX, Target_deDE, verified, translationRequest, bundle.</div>
      </div>
      <p-button
        label="Download"
        icon="pi pi-download"
        styleClass="p-button-sm p-button-outlined"
        (onClick)="downloadClientStringsCsvTemplate()"
      ></p-button>
    </div>

    <!-- Step 2: Options -->
    <div style="padding:0.75rem; background:var(--surface-100); border-radius:6px; display:flex; flex-direction:column; gap:0.6rem;">
      <p-checkbox
        [(ngModel)]="importCsvSkipExisting"
        [binary]="true"
        inputId="importCsvSkipExisting"
        label="Skip existing records (don't overwrite records that already exist)"
      ></p-checkbox>
      <p-checkbox
        [(ngModel)]="importCsvTriggerTranslation"
        [binary]="true"
        inputId="importCsvTriggerTranslation"
        label="Trigger AI translation for imported records"
      ></p-checkbox>
    </div>

    <!-- Step 3: File picker — IDLE (no file selected, no success) -->
    <ng-container *ngIf="!importCsvSelectedFile">
      <div
        class="csv-drop-zone"
        (click)="csvFileInput.click()"
        style="
          display:flex; flex-direction:column; align-items:center; justify-content:center;
          gap:0.5rem; padding:2rem; border:2px dashed var(--surface-border);
          border-radius:8px; cursor:pointer; text-align:center;
          transition: border-color 0.2s;
        "
      >
        <i class="pi pi-cloud-upload" style="font-size:2rem; color:var(--text-color-secondary);"></i>
        <div style="font-weight:600;">Click to choose a CSV file</div>
        <div style="font-size:0.82rem; color:var(--text-color-secondary);">Max 5 MB · .csv only</div>
      </div>
    </ng-container>

    <!-- Step 3b: File selected — ready to import -->
    <ng-container *ngIf="importCsvSelectedFile && !importCsvUploading">
      <div style="display:flex; align-items:center; gap:0.75rem; padding:0.75rem; background:var(--surface-100); border-radius:6px;">
        <i class="pi pi-file" style="font-size:1.4rem; color:var(--primary-color);"></i>
        <div style="flex:1; font-size:0.9rem;">
          <div style="font-weight:600; word-break:break-all;">{{ importCsvSelectedFileName }}</div>
          <div style="font-size:0.8rem; color:var(--text-color-secondary);">Ready to import</div>
        </div>
        <p-button
          icon="pi pi-times"
          styleClass="p-button-sm p-button-text p-button-secondary"
          (onClick)="clearImportCsvFile()"
          pTooltip="Remove file"
        ></p-button>
      </div>
      <!-- Validation errors from a previous attempt with this file -->
      <div *ngIf="importCsvErrors.length" style="padding:0.75rem; background:var(--surface-100); border-left:4px solid var(--red-500); border-radius:0 6px 6px 0;">
        <div style="display:flex; align-items:center; gap:0.5rem; margin-bottom:0.5rem;">
          <i class="pi pi-exclamation-triangle" style="color:var(--red-400);"></i>
          <strong>Validation errors — fix and re-upload</strong>
        </div>
        <ul style="margin:0; padding-left:1.25rem; max-height:160px; overflow-y:auto; font-size:0.85rem;">
          <li *ngFor="let err of importCsvErrors">Row {{ err.row }}: {{ err.message }}</li>
        </ul>
      </div>
      <p-button
        label="Import records"
        icon="pi pi-upload"
        styleClass="p-button-lg"
        [style]="{ width: '100%' }"
        (onClick)="runImportCsv()"
      ></p-button>
    </ng-container>

    <!-- Loading -->
    <ng-container *ngIf="importCsvUploading">
      <div style="display:flex; align-items:center; gap:0.75rem; padding:1rem; background:var(--surface-100); border-radius:6px;">
        <i class="pi pi-spin pi-spinner" style="font-size:1.4rem; color:var(--primary-color);"></i>
        <div>
          <div style="font-weight:600;">Importing…</div>
          <div style="font-size:0.82rem; color:var(--text-color-secondary);">Validating and writing records</div>
        </div>
      </div>
    </ng-container>


  </div>
</p-dialog>


